import { Component } from '@angular/core';
import { AnnouncementService } from 'src/app/services/announcement.service'; 
import { environment } from 'src/environments/environment';
interface QueryParams {
    fillter: string,
    sortObj: string,
    page: number,
    limit: number
}
@Component({
  selector: 'app-campaign',
  templateUrl: './campaign.component.html',
  styleUrls: ['./campaign.component.css']
})

export class CampaignComponent {

  pageSize = 10;
  currentPage = 0;
  pageSizeOptions: number[] = [10, 25, 50, 100];
  queryParams: QueryParams = {
    fillter: '{}',
    sortObj: '{}',
    page: this.currentPage + 1,
    limit: this.pageSize
  };
  imageUrls: string[] = [];
 constructor(
    private service: AnnouncementService,
  ) {
  }
 
  ngOnInit() {
    // Simulating backend API response
    this.fetchImages();
  }

fetchImages(): void {
  this.service.getAllOffers(this.queryParams).subscribe({
    next: (res: any) => {
      const baseUrl = environment.userApiUrl + '/slider/';
      this.imageUrls = res.result?.data
        .filter((img: any) => img.status === 'active' && img.modelName === 'offer')
        .map((img: any) => baseUrl + img.image);
    },
    error: () => {
      this.imageUrls = [];
    }
  });
}

}
